<template src="./SelectTree.html">
    
</template>
<script>
export default {
    data() {
        return {
            selectionType: 'independent',
            selection: [],
            items:[{
                    id: 1,
                    name: '',
                    children: [
    
                    ],
                },
            ],
            activatable:true,
            hoverable:true,
            shaped:true,
            rounded:true,
            arraySeleccion:[],
            search: null,
            banderaVerBuscador:false,
            openOnClick:true,
            active:[1]
        }
    },
    props:{
        filtro:{
            type: Object,
            default: {}
        },
        index:{
            type:Number,
        },
        banderaRecolectarFiltros:{
            type:Boolean,
            default:false
        }
    },
    created() {
        this.construirArrayFiltros()
    },
    watch: {
        selection(){
            this.construirArraySeleccion()
        
        },
        banderaRecolectarFiltros: function(valNew, valOld){
            console.log('SECOND - watch - myProp - ', valNew, ' ', valOld)
            if(valNew){
                this.$emit("jsonPeticion", this.jsonPeticion, this.index);

                // this.construirJsonPeticion()
            }
        },
        // banderaRecolectarFiltros(nuevoValor){
        //     console.log('nuevoValor:', nuevoValor)
        //     if(nuevoValor){
        //         this.construirJsonPeticion()
        //     }
            
        // }
    },
    beforeUpdate() {

    },
    methods: {
        verOpciones(){
            this.banderaVerBuscador=true
        },
        construirArrayFiltros(){
            this.items[0].name=this.filtro.categoria
            this.filtro.data.map((elemento, index)=>this.items[0].children.push({id:index+2, name:elemento}))
        },
        construirArraySeleccion(){
            const self= this
            this.arraySeleccion= this.selection.map((elemento, index)=>{
                return (self.items.map(elemento2=> {
                    return (elemento2.children.filter(element => element.id == elemento)[0]).name
                }))[0]
            })
            this.construirJsonPeticion()
        },
        construirJsonPeticion(){
            // if(this.arraySeleccion.length>0){
            this.jsonPeticion={
                categoria:this.items[0].name,
                data:this.arraySeleccion
            }
                // console.log('jsonPeticion:',this.items, jsonPeticion)
            // }
        }
    },
}
</script>
<style lang="scss" src="./SelectTree.scss" >

</style>


// WEBPACK FOOTER //
// src/components/SelectTree/SelectTree.vue